<template>
  <div>
    <div class="page-container">
      
      <el-autocomplete
        class="inline-input"
        v-model="dir"
        style="margin:5px 10px 0 0;width:350px"
        :fetch-suggestions="querySearch"
        placeholder="请输入目录"
        @select="handleSelect"
      ></el-autocomplete>
      <el-button style="height: 46px;" @click="getDayChatDetai_" type="primary"
        >查询</el-button
      >
      <el-button
        style="height: 46px;"
        type="primary"
        @click="dialogVisible = true"
        >删除</el-button
      >
      <el-select
        v-model="cover"
        style="margin:5px 0 0 10px;width:100px"
        placeholder="请选择"
      >
        <el-option
          v-for="(item, i) in covers"
          :key="i"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div style="margin:0 10px 0;width:100px ">
        <el-upload
          class="upload-demo"
          :limit="1"
          action=""
          :http-request="submitUpload"
          :on-exceed="fileExceed"
          ref="uploadRef"
        >
          <el-button style="height: 46px;" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <el-button type="primary" @click="submitUpload_" style="height: 46px;">
        点击上传
      </el-button>
    </div>
    <div v-loading="login1" class="page-container mg">
      <div v-for="(item, i) in tablele" :key="i">
        <div class="demo-image__preview">
          <el-image
            fit="contain"
            style="width: 150px; height: 150px"
            :src="item.url"
            :preview-src-list="[item.url]"
            lazy
          >
          </el-image>
        </div>
        <div>
          <el-tooltip :content="item.url" placement="bottom" effect="light">
            <el-button class="span" @click="copy(item.url)" type="success"
              >url
            </el-button>
          </el-tooltip>
          <el-button
            style="margin:0 10px 0;"
            @click="danger(item)"
            class="span"
            type="danger"
          >
            删除
          </el-button>
        </div>
      </div>
    </div>
    <!-- 删除弹出 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div v-if="!th">
        <el-input
          style="width:150px"
          show-password
          v-model="pwd"
          placeholder="请输入密码"
        ></el-input>
      </div>
      <div v-if="th">
        {{ data }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!th" @click="handleClose_">取 消</el-button>
        <el-button v-if="!th" type="primary" @click="delet_">确 定</el-button>
        <el-button v-if="th" type="primary" @click="handleClose_"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible_"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-input
          style="width:150px"
          show-password
          v-model="pwd"
          placeholder="请输入密码"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose_">取 消</el-button>
        <el-button type="primary" @click="delet_file">确 定</el-button>
      </span>
    </el-dialog>
    <input type="text" id="a1" style=" opacity:0;" v-model="value" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: {},
      th: false,
      value: '',
      login1: false,
      page: -1,
      data: '',
      table: [],
      tablele: [],
      dir: 'icon/',
      dialogVisible: false,
      dialogVisible_: false,
      pwd: '',
      id: '2',
      fileList: '',
      cover: 1,
      devEuiArr: [],
      covers: [
        {
          label: '覆盖',
          value: 1
        },
        {
          label: '不覆盖',
          value: 0
        }
      ]
    }
  },
  created () {
    this.getDayChatDetai()
    this.getDayChatDetai_()
  },
  watch: {},
  methods: {
    fileExceed (files, list) {
      const curFileUid = new Date() * 1;
      const file = files[0];
      file.uid = curFileUid;
      list[0].name = file.name;
      list[0].raw = file;
      list[0].uid = file.uid;
      list[0].size = file.size;
      
      this.submitUpload({file:list[0].raw});
    },
    handleSelect (item) {
      this.id = item.id
    },
    danger (item) {
      this.list = {
        dir: item.dir,
        fileName: item.fileName
      }
      this.dialogVisible_ = true
    },
    querySearch (queryString, cb) {
      this.devEuiArr = []
      for (let item of this.table) {
        this.devEuiArr.push({ value: item.dir, id: item.id })
      }
      let restaurants = this.devEuiArr
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    async getDayChatDetai () {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.dev_query_servers,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          page: this.page
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.message)
      this.table = res.data.data
    },
    async getDayChatDetai_ () {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.dev_restart_server,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          dir: this.dir
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.message)
      this.tablele = res.data
    },
    async delet_ () {
      this.login1 = true
      let data = new FormData()
      data.append('dir', this.dir)
      data.append('pwd', this.pwd)
      data.append('id', this.id)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.dev_restart_del +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        data
      )
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dialogVisible = false
      this.getDayChatDetai_()
    },
    async delet_file () {
      let data = new FormData()
      data.append('dir', this.list.dir)
      data.append('pwd', this.pwd)
      data.append('fileName', this.list.fileName)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.dev_file_del +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        data
      )
      if (res.code != 0) return this.$message(res.msg)
      this.dialogVisible_ = false
      this.getDayChatDetai_()
    },
    // 上传
    async submitUpload_ () {
      if(!this.fileList) {
        return this.$message.warning('文件不能为空')
      }
      let data = new FormData()
      data.append('file', this.fileList)
      data.append('dir', this.dir)
      data.append('cover', this.cover)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.dev_restart_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        data
      )
      if (res.code !== 0) return this.$message.error(res.message)
      this.$message.success('成功')
      this.$refs.uploadRef.clearFiles();
      this.fileList = '';
      this.data = res.data
      this.dialogVisible = true
      this.th = true
      this.getDayChatDetai_()
    },
    submitUpload (param) {
      console.log(param);
      let file = param.file
      this.fileList = file
    },
    handleClose (done) {
      this.pwd = ''
      this.th = false
      done()
    },
    handleClose_ () {
      this.pwd = ''
      this.th = false
      this.dialogVisible = false
      this.dialogVisible_ = false
    },
    copy (url) {
      let Url2 = document.getElementById('a1')
      Url2.value = url
      Url2.select()
     document.execCommand("copy");
     this.$message.success('copy success');
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  margin-left: 20px;
  margin-top: 20px;
  .span {
    width: 70px;
    margin: 10px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.mg {
  display: flex;
  flex-wrap: wrap;
  height: 70vh;
  overflow: scroll;
  > div {
    margin: 20px 10px 0;
  }
}
</style>
